import { Injectable } from "@angular/core";
import { SoApiService } from "./soapi.service";
import { MonitoringService } from "./monitoring.service";
import { PreferenceService } from "./preference.service";

// Applies category tags PostFormData couldn't (no live session for a CAE step-up) once we have one.
@Injectable({
  providedIn: "root",
})
export class CategoryTagSyncService {
  // Pinned add-ins re-run the resolver per item click; a throttle (not once-only) still picks up mid-session sends and transient failures.
  private static readonly MIN_INTERVAL_MS = 5 * 60_000;
  private lastSyncAt = Number.NEGATIVE_INFINITY;

  constructor(
    private readonly so: SoApiService,
    private readonly prefs: PreferenceService,
    private readonly monitoringService: MonitoringService
  ) {}

  async syncAsync(): Promise<void> {
    if (!this.prefs.isCategoryTaggingOnSendAndArchiveEnabled) {
      return;
    }

    const now = Date.now();
    if (now - this.lastSyncAt < CategoryTagSyncService.MIN_INTERVAL_MS) {
      return;
    }
    this.lastSyncAt = now;

    try {
      await this.so.applyPendingCategoryTags();
    } catch (error) {
      this.monitoringService.logFailed("CategoryTagSyncService.syncAsync", error);
    }
  }
}
